import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbRoleConstParam extends IAloDbBaseConstParam {
    ROL_ID:number|null  
    ROL_KEY:string|null
    ROL_LIBELLE:string|null    
    ROL_DESC:string|null
    ROL_SYSTEM_ON:boolean
  }

export class AloDbRole extends AloDbBase {
        
    public ROL_ID:number|null
    public ROL_KEY:string|null
    public ROL_LIBELLE:string|null
    public ROL_DESC:string|null
    public ROL_SYSTEM_ON:boolean
    
    constructor({ROL_ID,ROL_KEY,ROL_LIBELLE,ROL_DESC,ROL_SYSTEM_ON,...args }:IAloDbRoleConstParam = {} as IAloDbRoleConstParam) {
        super(args)
        this.ROL_ID = ROL_ID
        this.ROL_KEY = ROL_KEY
        this.ROL_LIBELLE = ROL_LIBELLE           
        this.ROL_DESC = ROL_DESC   
        this.ROL_SYSTEM_ON = ROL_SYSTEM_ON
    }

    static createAloDbRoleArray(datas:any) {
        return new AloBaseArray(AloDbRole,datas)
    }

    static createAloDbRoleWithDetail(data:any) {
        return new AloDbRole({...data,detailLoaded:true})
    }
}
